//
//
//
//
//
//
//
//
//
//

import { doctorFn } from '../../lib/correspondence'
export default {
  props: ['data'],
  // data: {
  //   text: 'text',
  //   useable: bool
  // },
  data () {
    return {
      // link: {
      //   text: '',
      //   imgValue: ''
      // }
    }
  },
  computed: {
  },
  methods: {
    getData: function (data) {
      let obj = {},
        that = this
      for (let i = 0, iLen = doctorFn.length; i < iLen; i++) {
        if (doctorFn[i].name === data.text) {
          obj.name = data.text
          obj.useable = data.useable
          if (obj.useable) {
            obj.imgValue = doctorFn[i].color
          } else {
            obj.imgValue = doctorFn[i].grey
          }
          break
        }
      }
      return obj
    }
  },
  mounted () {
    console.log(this.data)
  }
}



// WEBPACK FOOTER //
// ./src/components/clinic/doctorFn.vue